<template>
    <section>
        <div class="page-wrap">
            <div class="container">
                <div class="box-content">
                    <h2>Indian Creek Plaza Bricks Rus Version</h2>
                    <div class="font-lg">
                        <p>In Caldwell, we savor the good life. As we work--brick by brick--to establish our city as Idaho’s premier gathering place,
                            you have the opportunity to be a part of the growth,
                            specifically with a <strong>personalized brick</strong> on Indian Creek Plaza.
                        </p>
                        <p>As our community and visitors gather to celebrate the bounty of our land,
                            they will be reminded of just how much dedication and pride Caldwell has.
                            People truly care about their neighbors here. Indian Creek Plaza is set to be unveiled in early 2018,
                            in conjunction with the launch of year-round event programming.
                            Your brick, along with those of current and past residents, College of Idaho alumni, donors and friends,
                            will pave the way for future visitors to downtown Caldwell. This is a first for Caldwell – a plaza of bricks,
                            each with a special inscription. What a perfect way to show your pride, and celebrate your connection to Caldwell!
                            To be a part of this historic moment, order your brick today or give a gift certificate to a family member or friend.
                            We look forward to seeing you soon on Indian Creek Plaza.
                        </p>
                        <p><strong>Act now! Brick sales run through 12/31/17. Don't miss your chance to be a part of Indian Creek Plaza!</strong></p>
                        <p class="color-red">
                            <router-link to="/shop">
                                <strong>Click here to order your brick today!</strong>
                            </router-link>
                        </p>
                    </div>
                    <p>
                        <router-link to="/shop">
                            <img class="img-responsive" src="images/aboutbricks.png" alt="">
                        </router-link>
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/jsx">
    export default {
        name: 'about'
    }
</script>

<style lang="scss" scoped>
    p.color-red {
        a:hover, a:visited, a:link, a:active {
            text-decoration: none;
        }
        strong {
            color: #750020;
        }
    }
</style>



// WEBPACK FOOTER //
// About.vue?7eb3c64c